import { render, staticRenderFns } from "./YkCampDistributionIVRCalls.vue?vue&type=template&id=b45e168e&"
import script from "./YkCampDistributionIVRCalls.vue?vue&type=script&lang=js&"
export * from "./YkCampDistributionIVRCalls.vue?vue&type=script&lang=js&"
import style0 from "./YkCampDistributionIVRCalls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports